export default __webpack_public_path__ + "static/media/star.b11f3b4b.svg";